<script>
import Label from './Label.vue'

export default {
    props: {
        item: {
        type: Object,
        required: true,
        },
        selectedItem: {
        type: Object,
        required: false
        },
    },
    components: {
        Label
    },
    data() {
        return {
        };
    },   
    computed: {
    },
    watch: {
    }
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="cards-scrollable-item">
            <img :src="selectedItem.picture"
            class="banner">
        </div>
        <div v-if="selectedItem.additionalProp1 && selectedItem.additionalProp1.google && selectedItem.additionalProp1.apple" class="mt-4">
            <label class="w-100 font-theme-black-color font-weight-medium">
                Links
            </label>
            <a :href="selectedItem.additionalProp1.apple" target="_blank">
                <img class="cursor-pointer custom-size mr-3" src="@/assets/images/appstore.svg">
            </a>
            <a :href="selectedItem.additionalProp1.google" target="_blank">
                <img class="cursor-pointer custom-size" src="@/assets/images/googleplay.svg">
            </a>
        </div>
    </div>
</template>

<style scoped>
.banner {
    width: 350px;
    height: auto;
    margin: 0
}
.custom-size {
    width: 10em
}
</style>